<script lang="ts">
  import { onMount } from 'svelte';

  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { SpinnerType } from './SpinnerProps';

  export let light = false;
  export let size = '16px';
  export let type: SpinnerType = SpinnerType.Default;

  let iconName = 'icon-loading';

  $: iconColor = light ? 'white' : '';

  onMount(() => {
    iconName = getSpinner();
  });

  const getSpinner = (): string => {
    if (type === SpinnerType.Progress) return 'icon-spinner';
    return 'icon-loading';
  };
</script>

<div class="comp-spinner {type}" data-cy="spinner" style="--size:{size}">
  <Icon value="{iconName} {iconColor}" {size} fontSize={size} />
</div>

<style>
  .comp-spinner {
    width: var(--size);
    height: var(--size);
    transform-origin: center;
    animation: spin 1s cubic-bezier(0, 0, 0, 0) infinite;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .comp-spinner.progress {
    animation: spin 2s cubic-bezier(0, 0, 0, 0) infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
